import cn from 'classnames';
import { ReactNode } from 'react';
import styles from './section-header.module.scss';

export type SectionHeaderProps = {
  /**
   * a node to be rendered as icon
   */

  icon?: ReactNode;
  /**
   * Component title
   */
  title: ReactNode;
  /**
   * Hint to be rendered after the title
   */
  hint?: string;
  /**
   * Component description to be rendered below the title
   */
  description?: string;
  /**
   * Top action section that can render a button or a link
   */
  topAction?: ReactNode;
  /**
   * Wrapper className of the component. Useful to make more customizations.
   */
  className?: string;
};

export const SectionHeader = ({ title, className, icon, hint, description, topAction }: SectionHeaderProps) => (
  <div className={`${className || ''} ${styles.sectionHeaderWrapper}`}>
    {topAction ? <div className={styles.topActionWrapper}>{topAction}</div> : null}

    <div className={styles.mainContentWrapper}>
      {icon && <div className={styles.iconWrapper}>{icon}</div>}

      <div className={cn({ [styles.textWrapper]: !description })}>
        <h2 data-cy="page-title" className={cn(styles.titleWrapper, { [styles.withoutDescription]: !description })}>
          <span className={styles.title}>{title}</span>

          {hint && <span className={styles.hint}>{hint}</span>}
        </h2>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  </div>
);
